 $(document).on('click', '.tab-set-unique1 .tab-link', function() {

        var tabId = $(this).data('tab');
        var tabSet = $(this).closest('.tab-set');

        tabSet.find('.tab-link').removeClass('active');
        tabSet.find('.tab-content').hide();

        $(this).addClass('active');
        $('#' + tabId).fadeIn();
    });


  $(document).on('click', '.cp-stype-button-comman', function() {
         data = $(this).attr("data");
      $('body').removeClass("style-1-cp style-2-cp");
      $('body').addClass(data);
        $(".cp-stype-button-comman").removeClass("active");
        $(this).addClass('active');
    });

$(document).on("input",".input-dummy-discount",function() {

        // Get the value of input1
        var valueInput1 = $(this).val();
        // Set the value of input2 to the value of input1
        $('.discount-main').val(valueInput1);
      });

$(document).on("click",".discount-inner",function() {
  $(this).toggleClass("active");
  $(".discount-slide").slideToggle();
 });


$('.toggle-metafields').on('click change', function() {
  var $this = $(this); // Correctly reference the clicked element
  var currentText = $this.text();

  // Toggle the text
  $this.text(currentText === "Mehr erfahren" ? "Weniger erfahren" : "Mehr erfahren");

  // Get the target from the data attribute and slide toggle the target element
  var dataTarget = $this.attr("target");
  $(dataTarget).slideToggle();
  $(dataTarget).toggleClass("activec"); // Correctly select the target element
});

$('.specification-section .custom-sepc-show-more').on('click change', function() {
    var $this = $(this);
    var currentText = $this.text();

    // Toggle the text
    $this.text(currentText === "Mehr erfahren" ? "Weniger erfahren" : "Mehr erfahren");

    // Get the target from the data attribute and slide toggle the target element
    var dataTarget = $this.attr("target");
    $(dataTarget).slideToggle();  
   $(dataTarget+"css").toggleClass("activec");  
});





$(document).ready(function () {
    $(document).on("click", ".add-button.mobile-custom", function () {
        // Get all checked inputs with class "checked-input-upsell"
        var checkedInputs = $('.mobile-screen-only-custom .checked-input-upsell:checked');
        var items = [];

        // Collect the variant IDs and quantities (assumed to be 1 for simplicity)
        checkedInputs.each(function () {
            items.push({
                id: $(this).val(),
                quantity: 1
            });
        });

        if (items.length === 0) {
            alert("Please select at least one variant.");
            return;
        }

        // Call the function to update the cart
        addItemsMobile(items);
    });
}); // This closes the $(document).ready() function properly

// Function to add items to the cart
async function addItemsMobile(items) {
    console.log("Adding items for mobile:", items);

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items }), // Convert items array to JSON
        });

        const cartData = await response.json();

        if (response.ok) {
            console.log("Successfully added items:", cartData);

            // Dispatch custom cart refresh event
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { cart: cartData }
            }));

            // Update the cart icon status
            $(".cart-icon-trigger").attr("aria-expanded", "true");
        } else {
            console.error("Error adding items to the cart:", cartData);
            alert("Failed to add items to the cart.");
        }
    } catch (error) {
        console.error("Error during cart update:", error);
        alert("An error occurred. Please try again.");
    }
}





  $(document).on("change", ".upsell-pric-wrap select", function() {
    var $this = $(this);
    // Get the selected option value
    var selectedValue = $this.val();
    // Get the target input class from the 'data-target-input' attribute
    var targetInputClass = $this.attr('target-input');
    // Get the data-image attribute of the selected option
    var selectedImage = $this.find('option:selected').attr('dataimage');
    
    // Update the value of the target input field
    $(targetInputClass).attr("value", selectedValue);

   $(targetInputClass+"-img").attr("src", selectedImage);
    
   
   
});

 $(document).on('variant:changed', function(event) {
    let variant = event.originalEvent.detail.variant;
    let variantId = variant.id;
    let variantElement = $('#variant-' + variantId);

    if (variantElement.length > 0) {
        let restockDate = variantElement.attr('data-metafields');

        if (restockDate) {
            $('.inventory--empty .inventory--empty').html(restockDate);
        }
    }
});


function scrollLeft2() {
    document.querySelector('.custom-upsell-cart').scrollBy({
        left: -200, // Adjust to control scroll distance
        behavior: 'smooth'
    });
}

function scrollRight() {
    document.querySelector('.custom-upsell-cart').scrollBy({
        left: 200, // Adjust to control scroll distance
        behavior: 'smooth'
    });
}

function checkScroll() {
    const scrollContainer = document.querySelector('.custom-upsell-cart');
    const scrollLeftBtn = document.getElementById('scrollLeftBtn');
    const scrollRightBtn = document.getElementById('scrollRightBtn');

    // Show/hide the left arrow if there's content on the left
    if (scrollContainer.scrollLeft > 0) {
        scrollLeftBtn.classList.add('visible');
    } else {
        scrollLeftBtn.classList.remove('visible');
    }

    // Show/hide the right arrow if there's content on the right
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    if (scrollContainer.scrollLeft < maxScrollLeft - 1) { // Small buffer to account for precision
        scrollRightBtn.classList.add('visible');
    } else {
        scrollRightBtn.classList.remove('visible');
    }
}

// Check the scroll position on page load and after scroll events
document.addEventListener("DOMContentLoaded", checkScroll);
document.querySelector('.custom-upsell-cart').addEventListener('scroll', checkScroll);

